import { create } from 'zustand';

interface B2BSignUpFormState {
  formStep: number;
  setFormStep: (step: number) => void;
}

export const useB2BSignUpFormStore = create<B2BSignUpFormState>((set) => ({
  formStep: 1,
  setFormStep: (step: number) => set(() => ({ formStep: step })),
}));
